export const cloneControl = {
  defaultButton: `Clona`,
  defaultNoun: `impostazioni`,
  itemNounDefault: `queste impostazioni`,
  pullTitle: `Porta le impostazioni da un altro annuncio`,
  pushTitle: `Copia queste impostazioni su un altro annuncio`,
  pullSubReplace: `Verranno applicate a questo annuncio`,
  pullSubAdd: `Verranno aggiunte a quelle di questo annuncio`,
  pushSubReplace: `Verranno applicate a quelli che scegli`,
  pushSubAdd: `Verranno aggiunte a quelli che scegli`,
  pullTitleFull: `Porta {noun}`,
  pushTitleFull: `Copia {noun}`,
  pullSubtitle: `Scegli l'annuncio da cui portare le impostazioni. Verranno applicate a questo.`,
  pushSubtitle: `Copia queste impostazioni sugli annunci che scegli.`,
};
